/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
  children?: React.ReactNode;
  color?: string;
}

export const FltColorItem = styled.div<IProps>`
  cursor: pointer;

  .btn {
    ${mixin.flex({ justify: 'flex-start' })};
    width: 100%;
    height: 40px;
  }

  .name {
    font-size: 15px;
    font-weight: 400;
    line-height: 130%;
    color: #000;
    margin-left: 8px;
  }

  .cnt {
    font-size: 14px;
    font-weight: 500;
    line-height: 130%;
    color: #bbb;
    margin-left: 4px;
  }

  &.active {
    .color {
      border: 1px solid #000;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      height: ${mixin.pxToVw('40')};
    }

    .name {
      font-size: ${mixin.pxToVw('15')};
      margin-left: ${mixin.pxToVw('8')};
    }

    .cnt {
      font-size: ${mixin.pxToVw('14')};
      margin-left: ${mixin.pxToVw('4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .name {
      font-size: 16px;
    }

    .cnt {
      font-size: 15px;
      margin-left: 6px;
    }
  }
`;

export const Color = styled.span<IProps>`
  ${mixin.flex({})};
  border-radius: 100%;
  overflow: hidden;
  position: relative;
  width: 24px;
  height: 24px;
  background-color: #fff;

  .img {
    width: 20px;
    height: 20px;
    border-radius: 100%;
  }

  .bg-color {
    display: inline-block;
    border-radius: 100%;
    overflow: hidden;
    position: relative;
    width: 20px;
    height: 20px;
    background-size: 20px;
    // 화이트 컬러는 border 적용
    border: ${({ color }) =>
      /^#(fff|ffffff)$/i.test(color ?? '')
        ? '1px solid rgba(0, 0, 0, 0.1)'
        : 0};
    // 패턴과 메탈릭 컬러는 background 이미지 적용, 그 외에는 color 값 그대로 적용
    background: ${({ color }) =>
      color === 'pattern'
        ? `url("data:image/svg+xml,%3Csvg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ccircle cx='10' cy='10' r='10' fill='url(%23pattern0_2974_33946)'/%3E%3Cdefs%3E%3Cpattern id='pattern0_2974_33946' patternContentUnits='objectBoundingBox' width='1' height='1'%3E%3Cuse xlink:href='%23image0_2974_33946' transform='scale(0.015625)'/%3E%3C/pattern%3E%3Cimage id='image0_2974_33946' width='64' height='64' xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC'/%3E%3C/defs%3E%3C/svg%3E%0A");`
        : color === 'metallic'
        ? 'linear-gradient(225.47deg, #999999 12.24%, rgba(153, 153, 153, 0.1) 89.01%)'
        : color};
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('24')};
    height: ${mixin.pxToVw('24')};

    .img {
      width: ${mixin.pxToVw('20')};
      height: ${mixin.pxToVw('20')};
    }

    .bg-color {
      width: ${mixin.pxToVw('20')};
      height: ${mixin.pxToVw('20')};
      background-size: ${mixin.pxToVw('20')};
    }
  }
`;
